import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import reducers from "./combinedReducers";

const enhancer = composeWithDevTools(applyMiddleware(ReduxThunk));

const store = createStore(reducers, enhancer);

export default store;
